import React, { FC } from 'react';
import clsx from 'clsx';
import { colorFromString, initialsOf } from '../../utils/colorFromString';

interface Props {
  id: number;
  name?: string;
  surname?: string;
  size?: number;
  className?: string;
  channel?: boolean;
  channelName?: string | null;
}

// Renkli baş harf avatarı (DB'de foto yok). Kanal için '#' rozeti.
export const Avatar: FC<Props> = ({ id, name, surname, size = 42, className, channel = false, channelName }) => {
  const bg = channel ? colorFromString(`chan-${channelName || id}`) : colorFromString(`${id}-${name || ''}`);
  const label = channel ? '#' : initialsOf(name, surname);
  return (
    <div
      className={clsx('chat-avatar', className)}
      style={{ width: size, height: size, background: bg, fontSize: Math.round(size * 0.4) }}
      title={channel ? channelName || '' : `${name || ''} ${surname || ''}`.trim()}
    >
      {label}
    </div>
  );
};
